"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VisuallyHidden = void 0;
var visually_hidden_1 = require("./visually-hidden");
Object.defineProperty(exports, "VisuallyHidden", { enumerable: true, get: function () { return visually_hidden_1.VisuallyHidden; } });
//# sourceMappingURL=index.js.map